<template>
	<div>
		<section id="content">
			<div class="container">
				<br />


				<article class="message is-warning" v-if="!valueYear[1]">
					<div class="message-body"><strong>Data Load Error Detected!</strong><br />You may need to
						<a v-on:click.stop.prevent="reload">reload</a>
						the data, or use a different browser if the problem persists.</div>
				</article>




				<!-- NEW COMPONENT HERE -->
				<div class="filter is-mobile">

					<h2>Search Form</h2>

					<div style="padding: 2em 4em;"><input class="input" type='text' placeholder='Search...'
							v-model='searchQuery' /></div>

					<div class="sliderSection"><label>Year</label>
						<vue-slider ref="yearSlider" v-model="valueYear" v-bind="optionsYear" v-on:click.capture="test">
						</vue-slider>
					</div>

				</div>


				<div class="summary">
					<small class="rowCount">Showing <b>{{  itemCount }}</b> records
						<template v-if="valueYear[0] == valueYear[1]">
							<label>in <strong>{{ valueYear[0] }}</strong></label>
						</template>
						<template v-else>
							<label>between <strong>{{ valueYear[0] }} - {{ valueYear[1] }}</strong></label>
						</template>
					</small>
				</div>


				<table id="results-table" class="rtable rtable--flip" style="margin-bottom: 30px; white-space:normal;">
					<thead>
						<tr>
							<th>Item #</th>
							<th>Item Description</th>
							<th>Reason Held</th>
							<th>Confidential Period</th>
							<th>Reason for Revocation</th>
							<th class="has-text-centered">Documents</th>
						</tr>
					</thead>
					<tbody>
						<template v-for="(dates, date) in searchedArticles">

							<tr>
								<td colspan="6"><strong>{{ dateFormat(date) }}</strong></td>
							</tr>

							<template v-for="(list, type) in dates">
								<!-- <tr v-if="type != 'Council Meeting'"><td colspan="6" class="highlight">{{ type }}</td></tr> -->
								<tr>
									<td colspan="6" class="highlight">{{ type }}</td>
								</tr>
								<tr v-for="(item, index) in list">
									<td>{{ item.ITEM_NUMBER }}</td>
									<td>{{ item.ITEM_DESCRIPTION }}</td>
									<td>{{ item.REASON_CONFIDENCE }}</td>
									<td>{{ item.CONFIDENTIAL_PERIOD }}</td>
									<td>{{ item.REASON_FOR_REV }}</td>
									<td>
										<template v-if="item.AGENDA_LINK"><a :href="baseURL + item.AGENDA_LINK"
												target="_blank">Agenda</a><br /></template>
										<a v-if="item.MEETING_LINK" :href="baseURL + item.MEETING_LINK" target="_blank">Meeting</a>
									</td>
								</tr>
							</template>
						</template>
					</tbody>
				</table>



			</div>
		</section>

	</div>
</template>
<script>
	import moment from 'moment'; 

    export default {

        data() {
        	return {
						// baseURL: 'http://www.portenf.sa.gov.au/webdata/resources/minutesAgendas/',
						baseURL: 'https://www.cityofpae.sa.gov.au/?a=',
        		searchQuery: '',
        		dateItems: [],
        		itemCount: 0,
        		valueYear: [0,0],
                optionsYear: {
                    tooltipDir: 'bottom',
                    piecewise: true,
                    piecewiseLabel: true,
                    data: []
                }        		
        	}
        },

        mounted() {
        	this.getItems(),
        	this.getYearRange()
        },
  		
        computed: {

	        searchedArticles() {

 				var searchRegex = new RegExp(this.searchQuery, 'i');
            	var searchedArray = {};

				this.itemCount=0;

				for(var date in this.dateItems) {
					var i = 0;
					searchedArray[date] = {};
					var insertedItem = false;

					for( var meeting in this.dateItems[date] ) {

						searchedArray[date][meeting] = [];

						for( var item in this.dateItems[date][meeting] ) {

							var currItem = this.dateItems[date][meeting][item];
							var itemMatches = (this.searchQuery == '') ? true :  (
																					currItem.ITEM_DESCRIPTION.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1 || 
																					currItem.REASON_CONFIDENCE.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1 || 
																					currItem.CONFIDENTIAL_PERIOD.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1 ||
																					currItem.REASON_FOR_REV.toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1 
																					);

							if( itemMatches &&  currItem.MEETING_DATE.substring(0,4) >= this.valueYear[0] && currItem.MEETING_DATE.substring(0,4) <= this.valueYear[1]) {
								this.itemCount++;
								insertedItem = true;
								searchedArray[date][meeting].push(currItem);
							}

			                i++;

		            	}
		            }

		            if(!insertedItem) {
		            	delete searchedArray[date];
		            }

	            }

	            return searchedArray;

	        }

        },




        methods: {

            reload() {
                //this.getItems()
                this.getYearRange()
            },

			getItems: function() {
				axios.get('/api/confidential-items')
					.then(response => {
						this.dateItems = response.data;
					});
			},

            getYearRange: function() {
                axios.get('/api/confidential-items/yearRange')
                    .then(response => { 
                        this.optionsYear.data = response.data;
                        this.valueYear = [this.optionsYear.data[this.optionsYear.data.length -1]-1, this.optionsYear.data[this.optionsYear.data.length -1]]
                    });  
            },

	        dateFormat(date) {

	        	date = moment(date)
	        	return date.format('dddd, Do MMMM YYYY')

	        }            


        }
    }

</script>
<style>
	.stripe {
		background: #f9f9f9;
		border-top: 1px solid #ccc;
		border-bottom: 1px solid #ccc;
	}

	.no-border td {
		border: 0px;
	}

	.table.is-striped.no-border tbody tr:not(.is-selected):nth-child(even) td:not(.dateHeader) {
		border-top: 1px solid #dbdbdb;
		border-bottom: 1px solid #dbdbdb;
	}

	td.dateHeader {
		background: #fff;
		border-bottom: 3px solid #333;
		font-weight: bold;
		padding-top: 1em;
	}

	.minutePage {
		white-space: nowrap;
	}

	.seconded span {
		white-space: nowrap;
	}
</style>


// WEBPACK FOOTER //
// Modules/Register/Resources/assets/js/components/ConfidentialItems.vue